import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import * as React from 'react';

import { IAgentBonusSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { getCurrencySymbol } from '../../utils/formatters';
import * as styles from './index.css';

export interface IAgentFeedingProps {
  type?: string;
  agentBonus: IAgentBonusSchema | null;
}

export function AgentFeeding(props: IAgentFeedingProps) {
  const { type, agentBonus } = props;
  let text;
  let tooltipText;
  let tooltipTitle;

  if (type === 'without') {
    text = 'Просьба агентам не беспокоить';
    tooltipText = 'По какой-то причине этот агент не готов сотрудничать с другими агентами';
  } else if (type === 'feed' && agentBonus && agentBonus.paymentType && agentBonus.value) {
    const currency = agentBonus.currency && getCurrencySymbol(agentBonus.currency);

    text =
      agentBonus.paymentType === 'fixed'
        ? `Бонус агенту: ${numberToPrettyString(agentBonus.value)} ${currency}`
        : `Бонус агенту: ${agentBonus.value}%`;

    tooltipTitle = 'Бонус по успешной сделке';
    tooltipText = 'Агент указал, что готов поделиться комиссией в рамках указанного бонуса';
  } else {
    return null;
  }

  return (
    <div className={styles['container']}>
      <span className={styles['text']}>{text}</span>
      <div className={styles['info']}>
        <div className={styles['icon']} />
        <div className={styles['tooltip']}>
          <div className={styles['tooltip-content']}>
            {tooltipTitle && <h3 className={styles['tooltip-title']}>{tooltipTitle}</h3>}
            <span className={styles['tooltip-text']}>{tooltipText}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
